import { z } from 'zod';

import type { Translate } from '@src/i18n/useTranslate';

export const requiredEmailFieldSchema = (t: Translate['i18n']) => {
  const requiredMessage = t('checkout_auth_required_field');
  const invalidEmailMessage = t('checkout_auth_invalid_email');

  return z.string({ required_error: requiredMessage }).min(1, requiredMessage).email({ message: invalidEmailMessage });
};
